// extracted by mini-css-extract-plugin
module.exports = {"mobileItem":"styles_mobileItem__3hZTK","dates":"styles_dates__3s7fe","amounts":"styles_amounts__2paaA"};